import React, { useEffect, useState } from 'react';
import api from '../api';

const styles = {
  container: {
    maxWidth: 480,
    margin: '0 auto',
    padding: '0 0 80px',
    minHeight: '100vh',
    background: '#fff',
  },
  header: {
    padding: '2rem 1.25rem 1rem',
    borderBottom: '1px solid #f0f0f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
  },
  addBtn: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    border: '1.5px solid #1a1a1a',
    background: 'transparent',
    fontSize: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  },
  sectionLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: '#888',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    padding: '1.25rem 1.25rem 0.5rem',
  },
  sessionCard: {
    margin: '0 1.25rem 10px',
    border: '1px solid #ebebeb',
    borderRadius: 12,
    padding: '1rem 1.25rem',
  },
  sessionTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  sessionType: {
    fontSize: 15,
    fontWeight: 600,
  },
  sessionDate: {
    fontSize: 12,
    color: '#888',
  },
  statsRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 8,
  },
  statBox: {
    background: '#f8f8f8',
    borderRadius: 8,
    padding: '8px 10px',
  },
  statLabel: {
    fontSize: 10,
    color: '#888',
    marginBottom: 2,
  },
  statValue: {
    fontSize: 14,
    fontWeight: 600,
  },
  empty: {
    textAlign: 'center',
    padding: '3rem 1.25rem',
    color: '#aaa',
    fontSize: 14,
  },
  modal: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    zIndex: 100,
  },
  modalSheet: {
    background: '#fff',
    width: '100%',
    maxWidth: 480,
    borderRadius: '16px 16px 0 0',
    padding: '1.5rem 1.25rem 2rem',
  },
  modalTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: '1rem',
  },
  dayBtn: {
    display: 'block',
    width: '100%',
    padding: '14px',
    marginBottom: 10,
    border: '1px solid #ebebeb',
    borderRadius: 10,
    background: '#fff',
    fontSize: 15,
    fontWeight: 500,
    textAlign: 'left',
  },
  cancelBtn: {
    display: 'block',
    width: '100%',
    padding: '14px',
    marginTop: 4,
    border: 'none',
    borderRadius: 10,
    background: '#f5f5f5',
    fontSize: 14,
    color: '#888',
    textAlign: 'center',
  },
};

export default function HomeScreen({ onStartWorkout, onViewSession, onViewProgress, onLogout, user }) {

  const [sessions, setSessions] = useState([]);
  const [workoutTypes, setWorkoutTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    api.get('/sessions').then(r => setSessions(r.data));
    api.get('/workout-types').then(r => setWorkoutTypes(r.data));
  }, []);

  const handleSelectType = async (type) => {
    const today = new Date().toISOString().split('T')[0];
    const res = await api.post('/sessions', {
      workout_type_id: type.id,
      date: today,
    });
    setShowModal(false);
    onStartWorkout({ ...res.data, workout_type_name: type.name });
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const formatDuration = (secs) => {
    if (!secs) return null;
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}m ${s}s`;
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <div style={styles.title}>Gym Tracker</div>
          <div style={{ fontSize: 12, color: '#aaa' }}>Hey, {user?.username}!</div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button
            style={{ ...styles.addBtn, width: 'auto', borderRadius: 20, padding: '6px 12px', fontSize: 13 }}
            onClick={onViewProgress}
          >
            Progress
          </button>
          <button
            style={{ ...styles.addBtn, width: 'auto', borderRadius: 20, padding: '6px 12px', fontSize: 13, color: '#888', borderColor: '#ddd' }}
            onClick={onLogout}
          >
            Logout
          </button>
          <button style={styles.addBtn} onClick={() => setShowModal(true)}>+</button>
        </div>
      </div>

      <div style={styles.sectionLabel}>Recent Workouts</div>

      {sessions.length === 0 && (
        <div style={styles.empty}>No workouts yet — hit + to start your first session!</div>
      )}

      {sessions.map(s => (
        <div key={s.id} style={{ ...styles.sessionCard, cursor: 'pointer' }} onClick={() => onViewSession(s.id)}>
          <div style={styles.sessionTop}>
            <span style={styles.sessionType}>{s.workout_type_name} Day</span>
            <div style={{ textAlign: 'right' }}>
              <div style={styles.sessionDate}>{formatDate(s.date)}</div>
              {s.duration_seconds > 0 && (
                <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>
                  {formatDuration(s.duration_seconds)}
                </div>
              )}
            </div>
          </div>
          <div style={styles.statsRow}>
            <div style={styles.statBox}>
              <div style={styles.statLabel}>Total weight</div>
              <div style={styles.statValue}>{s.total_weight.toLocaleString()} lbs</div>
            </div>
            <div style={styles.statBox}>
              <div style={styles.statLabel}>Total reps</div>
              <div style={styles.statValue}>{s.total_reps}</div>
            </div>
            <div style={styles.statBox}>
              <div style={styles.statLabel}>Avg / rep</div>
              <div style={styles.statValue}>{s.avg_per_rep} lbs</div>
            </div>
          </div>
        </div>
      ))}

      {showModal && (
        <div style={styles.modal} onClick={() => setShowModal(false)}>
          <div style={styles.modalSheet} onClick={e => e.stopPropagation()}>
            <div style={styles.modalTitle}>Select workout type</div>
            {workoutTypes.map(type => (
              <button key={type.id} style={styles.dayBtn} onClick={() => handleSelectType(type)}>
                {type.name} Day
              </button>
            ))}
            <button style={styles.cancelBtn} onClick={() => setShowModal(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}